import type { Currency, Period, Quarter } from './global.types';
import type { UserCountry } from './users.types';

export type ExportParams = {
  quarter: Quarter;
  year: number;
  modules: string;
  unvalidatedExpenses?: boolean;
  lang: number;
  sendEmail: boolean;
  async: boolean;
  datevValue?: string;
  ublValue?: string;
  customerCountry: UserCountry;
  period: any;
  exportModules: string[];
};

export type ExportEntry = {
  export: {
    created: string;
    expires: string;
    filePath: string;
    linkToFile: string;
    modules: string[];
    period: Period;
    rid: string;
    sendEmail: string;
    status: string;
    type: string;
    userId: string;
    _id: string;
    error?: string;
    result?: {
      chiftExport: {
        errors?: { chift?: Record<string, string[]> };
        expense_errors: string[];
        invoice_errors: string[];
        success: boolean;
        time: number;
        transaction_errors: string[];
      };
    };
    failedExpenses: {
      amount: number;
      expenseDate: string;
      supplier: { name: string; country: string };
      _id: string;
    }[];
    failedRevenues: {
      baseCurrencyTotalAmountInclVAT: number;
      currency: Currency;
      invoiceDate: string;
      revenueNumber: string;
      _id: string;
    }[];
    failedTransactions: any[];
  };
};

export type ExportDocument = {
  key: string;
  blob: any;
};

export type ExportResource = {
  type: 'export';
  params: ExportParams;
  customerId: string;
  key: string;
};

export enum ExportModulesEnum {
  PL = 'pl',
  DATEV = 'datev',
  EXCEL = 'excel',
  ORIGINAL_DOCUMENTS = 'original_documents',
  UBL = 'ubl',
  CODA = 'coda',
  PDF = 'pdf',
  AMORTISATION_TABLE = 'amortisation_table',
  PROFIT_AND_LOSS = 'profit_and_loss',
  BWA = 'bwa',
}

export type LockedExportModule =
  | {
      key: 'pl';
      value: ExportModulesEnum.PL;
      disabled?: boolean;
      lock?: 'report_PL';
    }
  | { key: 'datev'; value: ExportModulesEnum.DATEV; lock?: 'datev' };

export type ExportModule =
  | LockedExportModule
  | { key: 'excel'; value: ExportModulesEnum.EXCEL }
  | { key: 'original_documents'; value: ExportModulesEnum.ORIGINAL_DOCUMENTS }
  | { key: 'ubl'; value: ExportModulesEnum.UBL }
  | { key: 'coda'; value: ExportModulesEnum.CODA };

export type DatevField =
  | { label: 'datevId'; placeholder: '1048759' }
  | { label: 'datevAccountantId'; placeholder: '4862886' }
  | { label: 'datevDefaultSalesAccount19'; placeholder: '8400' }
  | { label: 'datevDefaultSalesAccount7'; placeholder: '8300' }
  | { label: 'datevDefaultSalesAccount0'; placeholder: '8100' };

export type SkrType = 'skr03' | 'skr04';

export type DatevSettings = {
  clientNumber: string;
  accountantNumber: string;
  defaultSalesAccount?: {
    skr03: string;
    skr04: string;
  };
};

export enum DocumentExportStatus {
  FAILED = 'failed',
  SUCCEEDED = 'succeeded',
  RESOLVED = 'resolved',
}

export enum ExportedDocumentType {
  EXPENSE = 'expense',
  REVENUE = 'revenue',
  TRANSACTION = 'transaction',
}

export type ChiftExportDocument = {
  _id: string;
  name: string;
  status: DocumentExportStatus;
  documentType: ExportedDocumentType;
  failureReason?: string;
  created: string;
  modified: string;
  userId: string;
  integrationId: string;
  exportModuleId: string;
  softwareSlug: string;
  documentId: string;
};
